import * as http from "http";

export default function slugFromRequest(
  query: Record<string, string | string[] | undefined>,
  req: http.IncomingMessage | undefined
): string {
  if (process.browser) {
    const { hostname } = window.location;
    const subdomain = hostname.split(".")[0];

    if (subdomain !== "localhost") {
      return subdomain;
    }

    if (!query.slug) {
      throw new Error("Missing slug on query string");
    }

    return query.slug as string;
  }

  if (req) {
    /**
     * Forced `as any` because the .query is not declared on the IncomingMessage type
     */
    const slugFromQuery = ((req as any).query || {}).slug || query.slug;
    if (slugFromQuery) {
      return slugFromQuery;
    }
  }

  throw new Error("Slug not found");
}
